export default [
  {
    path: '/real-estate-developments-settings/bank-agencies',
    name: 'BankAgenciesList',
    component: () => import('pages/real-estate-developments-settings/bank-agencies/BankAgenciesList.vue')
  },
  {
    path: '/real-estate-developments-settings/bank-agencies/new',
    name: 'BankAgenciesCreate',
    component: () => import('pages/real-estate-developments-settings/bank-agencies/BankAgenciesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/bank-agencies/:id/edit',
    name: 'BankAgenciesEdit',
    component: () => import('pages/real-estate-developments-settings/bank-agencies/BankAgenciesForm.vue')
  }
]
